import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connect } from 'react-redux';
import { initialize } from './actionCreators';
import { getIsInitialized, getTooltipState } from './selectors';
import { getCurrentUser } from '../../publicSession/selectors';
const mapStateToProps = (state, ownProps)=>{
    const { username } = ownProps;
    const currentUser = getCurrentUser(state);
    return _object_spread({
        isInitialized: getIsInitialized(state, username),
        isOwner: currentUser && currentUser.username === username
    }, getTooltipState(state, username));
};
const mapDispatchToProps = (dispatch)=>({
        initialize: (username)=>dispatch(initialize(username))
    });
export default connect(mapStateToProps, mapDispatchToProps);
